<template>
    <el-container style="height:100%">
        <el-aside :style="{ width: elAsideWidth + 'px' }">
            <el-row style="height:100%">
                <el-col :span="24">
                    <el-menu style="height:100%;border:none" @open="handleOpen" :unique-opened="true" :collapse="collapse"
                        background-color="#1f2430" text-color="#fff" active-text-color="#6a66ff"
                        :default-openeds="defaultOpened" :collapse-transition="false">
                        <el-container>
                            <el-main style="display:flex;">
                                <!-- <el-image :src="logoUrl" style="width:50px;height:50px;"></el-image> -->
                                <span style="color: #fff;line-height: 50px;padding: 0px 5px;"
                                    :style="{ display: isNone }">裕优客代理商平台</span>
                            </el-main>
                        </el-container>
                        <template v-for="(route, pKey) in router" :key="route">
                            <template v-if="route.name != 'login' && route.name != '404'">
                                <el-sub-menu :index="pKey + ''">
                                    <template #title>
                                        <el-icon>
                                            <span class="iconfont" :class="route.meta.icon" style="color:#6a66ff"></span>
                                        </el-icon>
                                        <span>{{ route.name }}</span>
                                    </template>
                                    <template v-for="(children, cKey) in route.children" :key="children">
                                        <el-menu-item :index="pKey + '-' + cKey" @click="selectItemMenu">
                                            <router-link :to="children.path" style="text-decoration:none;">
                                                <span style="color:#fff">
                                                    {{ children.name }}
                                                </span>
                                            </router-link>
                                        </el-menu-item>
                                    </template>
                                </el-sub-menu>
                            </template>
                        </template>
                    </el-menu>
                </el-col>
            </el-row>

        </el-aside>
        <el-container>
            <el-header class="header">
                <el-row style="margin-top:10px;">
                    <el-col :span="1">
                        <span style="color:#fff;font-size:25px;height:40px;line-height:48px;cursor: pointer;"
                            @click="isShowMenu">
                            <el-icon v-if="collapse">
                                <Expand />
                            </el-icon>
                            <el-icon v-else>
                                <Fold />
                            </el-icon>
                        </span>
                    </el-col>
                    <el-col :span="11">
                        <el-breadcrumb separator=">" style="height:40px;line-height:40px">
                            <el-breadcrumb-item>
                                <span class="text-color">{{ breadcrumbNames[0] }}</span>
                            </el-breadcrumb-item>
                            <el-breadcrumb-item>
                                <span class="text-color">{{ breadcrumbNames[1] }}</span>
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </el-col>
                    <el-col :span="12" style="text-align:right">
                        <el-dropdown style="margin-right:15px">
                            <span class="el-dropdown-link" style="height:40px;line-height:40px">
                                <span style="color:#fff">
                                    {{ agentName }}
                                    <el-icon>
                                        <ArrowDown />
                                    </el-icon>
                                </span>
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item @click="logout">退出</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                        <el-avatar :size="40" :src="circleUrl" />
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-tabs class="tabs" type="card" :model-value="isActive" closable style="margin:-20px"
                    @tab-remove="removeTab" @tab-click="clickTab">
                    <template v-for="(tab, index) in tabsList" :key="tab">
                        <el-tab-pane :label="tab.title" :name="index + '-' + tab.path" style="padding:20px">
                            <el-config-provider :locale="locale">
                                <router-view :name="tab.name"></router-view>
                            </el-config-provider>
                        </el-tab-pane>
                    </template>
                </el-tabs>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import { ArrowDown, Expand, Fold } from '@element-plus/icons-vue'
import pathTools from '@/tools/pathTools'
import { store } from '@/common/store'
import storeTools from '@/tools/storeTools'
import logoImg from '@/assets/logo.png'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

export default {
    components: {
        ArrowDown,
        Expand,
        Fold
    },
    data() {
        return {
            router: "", // 路由
            defaultOpened: [], // 路由默认开启的导航栏
            breadcrumbNames: [], // 面包屑
            tabsList: [], // 选项卡标签列表
            isActive: '', // 显示的标签
            logoUrl: logoImg, // 平台log
            circleUrl: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202107%2F09%2F20210709142454_dc8dc.thumb.1000_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1664355871&t=5d08c548798eb689d0a14d1c89548525", // 代理商头像
            screenWidth: null, // 屏幕宽度
            collapse: false, // 是否展开或隐藏导航栏
            isNone: 'block', // 是否隐藏或显示log文案
            elAsideWidth: 200, // 导航栏宽度
            agentName: '', // 代理商会员名称
            locale: zhCn
        };
    },
    watch: {
        screenWidth: function (n) {
            if (n <= 800) {
                this.showMenu(true)
            } else {
                this.showMenu(false)
            }
        }
    },
    beforeMount() {
        this.loadPath()
        this.setDefaultOpened()
        this.setBreadcrumbNames()
        this.setTabsList()
        this.setIsActive()
    },
    mounted() {
        this.screenWidth = document.body.clientWidth
        window.onresize = () => {
            //屏幕尺寸变化
            return (() => {
                this.screenWidth = document.body.clientWidth
            })()
        }
        this.updateAgentInfo()
    },
    updated() {
        this.setIsActive()
        this.setBreadcrumbNames()
        this.setTabsList()
    },
    methods: {
        /**
         * menu点击事件
         */
        selectItemMenu() {
            this.setBreadcrumbNames()
            this.setTabsList()
            this.setIsActive()
        },
        /**
         * 加载路由
         */
        loadPath() {
            this.router = pathTools.loadPath()
        },
        /**
         * 记录展开的路由的序号
         * @param {*} key 
         */
        handleOpen(key) {
            store.setMenuIndex(key)
        },
        /**
         * 设置默认展开的路由
         */
        setDefaultOpened() {
            this.defaultOpened = [store.menuIndex]
        },
        /**
         * 设置面包屑文本
         */
        setBreadcrumbNames() {
            this.breadcrumbNames = store.getBreadcrumbNames()
        },
        /**
         * 设置tab
         */
        setTabsList() {
            this.tabsList = storeTools.getTabs()
        },
        /**
         * tab删除
         * @param {string} index 
         */
        removeTab(index) {
            if (this.tabsList.length <= 1) {
                return
            }

            const indexArr = index.split('-')
            let i = Number(indexArr[0])

            /**
             * 删除tab标签
             */
            this.tabsList.splice(i, 1)
            storeTools.removeTab(i)

            /**
             * 如果删除的是当前选中的才重新选择tab标签项
             */
            const tabs = storeTools.getTabs()
            const nextTab = tabs[i - 1] || tabs[i] || tabs[i + 1]

            if (index == this.isActive) {
                this.$router.replace({ path: nextTab.path })
            }

            const activeArr = this.isActive.split('-')
            let ai = Number(activeArr[0])

            if (i < ai) {
                this.isActive = (ai - 1) + '-' + activeArr[1]
            }
        },
        /**
         * 点击tab标签项目
         */
        clickTab(pane) {
            const path = pane.props.name.split('-')[1]
            this.$router.replace({ path: path })
        },
        /**
         * 设置tab默认展示标签项
         */
        setIsActive() {
            this.isActive = store.getIsActive()
        },
        isShowMenu() {
            this.showMenu(!this.collapse)
        },
        /**
         * @param {boolean} collapse true 隐藏,false 展开
         */
        showMenu(collapse) {
            if (collapse) {
                this.elAsideWidth = 64
                this.isNone = 'none'
            } else {
                this.elAsideWidth = 200
                this.isNone = 'block'
            }
            this.collapse = collapse
        },
        /**
         * 更新代理商信息
         */
        updateAgentInfo() {
            const agentUser = JSON.parse(sessionStorage.getItem('agent_user'))
            this.agentName = agentUser.company
        },
        /**
         * 退出
         */
        logout() {
            sessionStorage.clear()
            this.$router.push({ path: '/login' });
        }
    }
}
</script>

<style lang="less">
html,
body,
#app {
    margin: 0;
    height: 100%;
}

.header {
    background-color: #6a66ff;
    color: #fff
}


.footer {
    background-color: #e5e5f6;
    color: #1f2430;
    text-align: center;
    line-height: 60px;
}

.text-color {
    color: #fff;
}
</style>
